import React from "react";
import cx from "classnames";
import { Link } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import styles from "./basket.module.css";
import BasketRow from "./basket-row";
import BasketItem from "./basket-item";
import { Button } from "../button";
import { connect } from "react-redux";
import {
  orderedProductsSelector,
  totalPriceSelector
} from "../../redux/selectors";
import "./basket.css";
import { useMoney } from "../../hooks/use-money";

function Basket({
  title = "Basket",
  className,
  total,
  orderProducts,
  hideButton
}) {
  const m = useMoney();
  if (!total) {
    return (
      <div className={cx(styles.basket, className)}>
        <h4 className={styles.title}>Select a meal from the list</h4>
      </div>
    );
  }

  return (
    <div className={cx(styles.basket, className)}>
      <h4 className={styles.title}>Basket</h4>
      <TransitionGroup>
        {orderProducts.map(({ product, amount, restaurant }) => (
          <CSSTransition
            timeout={500}
            classNames="basket-item-animation"
            key={product.id}
          >
            <BasketItem
              product={product}
              amount={amount}
              restaurant={restaurant}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>
      <hr className={styles.hr} />

      <BasketRow leftContent="Sub-total" rightContent={m(total)} />
      <BasketRow leftContent="Delivery costs:" rightContent="FREE" />
      <BasketRow leftContent="total" rightContent={m(total)} bold />
      {!hideButton && (
        <Link to="/checkout">
          <Button type="primary" block className={styles.button}>
            checkout
          </Button>
        </Link>
      )}
    </div>
  );
}

export default connect(state => ({
  total: totalPriceSelector(state),
  orderProducts: orderedProductsSelector(state)
}))(Basket);
